module.exports = __webpack_public_path__ + "static/media/armor.f1ecb269.png";